import { DASHBOARD_CONTAINER, PAGE_LOADER } from '../../../../types/types';
import { parseTerminalInfo, getCardGroupData } from '../form-tcg-helpers';
import { LINK_CG_TERMINAL_FORM } from '../form-tcg-types';
import { addTerminalCardGroup } from './add-terminal-cardgroup';
import { displayCardGroups } from '../../../widgets/cardgroup-widget';
import { searchClear } from '../../form-search';
import { TerminalCardGroup } from '../../../../models/terminal.interface';

import { displayIndividualTerminal } from '../../../../routes/get-terminal-individual';
import { getTerminalCardGroup } from '../../../../routes/get-terminal-card-group';
import GetCardGroups from '../../../../routes/get-card-groups';

/**
 * Function that controls linking card groups to a given terminal on the Link Card Group and Terminals form
 * 
 * @param {string} terminalId the terminals id
 * @param {string} customerId the customers id
 * @param {string} partnerId the partners id
 */
export const linkTerminaltoCardGroup = async (terminalId: string, customerId: string, partnerId: string) => {
  const awsModelData = {
    terminalID: terminalId
  }

  const [ terminal, cardGroup, allCardGroups ] = await Promise.all([
    displayIndividualTerminal(terminalId),
    getTerminalCardGroup(awsModelData),
    GetCardGroups(customerId, partnerId)
  ]);

  const { body: terminalList } = terminal;
  const { body: AvalCardGroupList } = allCardGroups;
  const { body: LinkedCardGroupList } = cardGroup;

  const avalCardGroups = AvalCardGroupList.filter(item => LinkedCardGroupList.every(item2 => item2.cardGroupId != item.cardGroupId));

  parseTerminalInfo(terminalList);
  getCardGroupData(avalCardGroups);
  displayCardGroups(LinkedCardGroupList, LINK_CG_TERMINAL_FORM.searchSelected);  

  getSelectedCardGroup(LINK_CG_TERMINAL_FORM.searchResults, LINK_CG_TERMINAL_FORM.searchSelected, terminalId);

  PAGE_LOADER.loaderContainer.classList.add('aafp_no-show');
  DASHBOARD_CONTAINER.removeAttribute('style');
}

/**
 * Selects and removes card groups from the available card groups list
 * 
 * @param {HTMLElement} avalContainer the HTML element that has available terminals
 * @param {HTMLElement} resultsContainer the HTML element that has associated terminals
 * @param {string} terminalId the id of the terminal the card groups are being associated with
 * 
 * @returns void
 */
const getSelectedCardGroup = ( avalContainer: HTMLElement, resultsContainer: HTMLElement, terminalId: string ) => {
  avalContainer?.addEventListener('click', e => {
    const target = e.target as HTMLElement;
    if(target != this && target.classList.contains('get-selected-element')) {
      target.parentElement!.remove();  
      const data = [{ cardGroupId: +target.dataset.id!, cardGroupName: target.dataset.name! }];
      displayCardGroups(data, resultsContainer);           
      addTerminalCardGroup(terminalId);      
    } 

    searchClear(LINK_CG_TERMINAL_FORM.searchInput, LINK_CG_TERMINAL_FORM.searchResults);
  });
}
